import { CSSProperties } from 'react';
import { COLORS, CONTENT_COLUMN, FONTS, META } from '../../globalStyles';

export const styles: Record<string, CSSProperties> = {
  section: {
    ...CONTENT_COLUMN,
    padding: '7rem 6vw',
  },
  // The "spec block" opener: a hairline rule (draws in on reveal) with an
  // index + label sitting beneath it.
  band: {
    marginBottom: '2rem',
  },
  bandLine: {
    display: 'block',
    height: '1px',
    width: '100%',
    background: COLORS.borderStrong,
    transformOrigin: 'left',
    transition: 'transform 0.7s cubic-bezier(0.2,0.7,0.2,1)',
  },
  bandRow: {
    display: 'flex',
    alignItems: 'center',
    gap: '1.25rem',
    paddingTop: '1.1rem',
  },
  index: {
    ...META,
    fontSize: '0.72rem',
    color: COLORS.accent,
  },
  label: {
    ...META,
    fontSize: '0.72rem',
    color: COLORS.label,
  },
  heading: {
    fontFamily: FONTS.display,
    fontStretch: '125%',
    fontSize: 'clamp(1.6rem, 3.2vw, 2.5rem)',
    fontWeight: 600,
    letterSpacing: '-0.01em',
    lineHeight: 1.12,
    marginBottom: '1rem',
    color: COLORS.text,
  },
  sub: {
    color: COLORS.muted,
    maxWidth: '520px',
    lineHeight: 1.7,
    fontSize: '1rem',
  },
};
